import {Suspense, lazy} from 'react'
import Loader from "../customs/loader/main"

const Main = lazy(() => import("../components/login/main"))

const Login = () => {
  return (
    <Suspense fallback={<Loader />}> 
        <Main />
    </Suspense>
  )
}

export default Login